 
<div class="profile-container">
    <div class="">
        <div class="profile-content">
          <!-- <button class="add-Scheme" data-toggle="modal" data-target="#exampleModal">Add user</button> -->
  
            <div class="personal-details">
                <!-- <h4 class="personal-details-title">Create Users</h4> -->
                <!-- <table class="table">
                  <thead>
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">Firstname</th>
                      <th scope="col">Lastname</th>
                      <th scope="col">Username</th>
                      <th scope="col">Email</th>
                      <th scope="col">Password</th>
                      <th scope="col">Action</th>
                      
                    </tr>
                  </thead>
                  <tbody *ngFor="let x of data ;let i = index">
                      <th scope="col">{{i+1}}</th>
                      <th scope="col">{{x.firstName}}</th>
                      <th scope="col">{{x.lastName}}</th>
                      <th scope="col">{{x.username}}</th>
                      <th scope="col">{{x.email}}</th>
                      <th scope="col">{{x.password}}</th>
                      <svg  style="cursor: pointer;" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pencil-square" viewBox="0 0 16 16">
                        <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
                        <path fill-rule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"/>
                      </svg>
                      
                      
                      <svg  style="cursor: pointer;" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash3" viewBox="0 0 16 16">
                       <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5ZM11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 0H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1h-.995a.59.59 0 0 0-.01 0H11Zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5h9.916Zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47ZM8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z"/>
                      </svg>
                  </tbody>
              </table> -->

              <div class="row user-communication">
                <div class="col-lg-3 col-md-3">
                    <div class="users-list">
                        <div class="users-list-header">
                            <div class="users-list-header-title">
                                <h3 (click)="userDropDown()" >Add User chart</h3>
                            </div>
                            <div class="dropdown-data" id="user-drop-down">
                                <ul>
                                    <li class="search-user">
                                        <input type="text" [(ngModel)]="searchUserFilter" placeholder="Search User" class="form-control">
                                    </li>
                                    <li *ngFor="let user of userList | filter: searchUserFilter">
                                        <div (click)="insertConversation(user.userName,user.userId)">
                                            <p>{{user.userName}}</p>
                                            <p>{{user.userEmail}}</p>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="userlist-data" *ngFor="let userList of userConversationList;let i = index">
                            <div class="single-user" *ngIf="userList.conversationType == 'ONE_TO_ONE'" (click)="getSingleConversation(userList.id,userList.userIdNameList[1].userName,'ONE_TO_ONE')">
                                <img src="assets/img/dummy-image.jpeg" class="img-avater" alt="" />
                                <div>
                                    <p>{{userList.userIdNameList[1].userName}}</p>
                                    <p>{{userList.userIdNameList[1].userName}}</p>
                                </div>
                            </div>
                            <div class="single-user" *ngIf="userList.conversationType == 'TICKET'" (click)="getSingleConversation(userList.id,userList.userIdNameList[0].userName,'TICKET')">
                                <img src="assets/img/dummy-image.jpeg" class="img-avater" alt="" />
                                <div>
                                    <p>{{userList.conversationType}} {{userList.ticketTaskId}}</p>
                                    <p>{{userList.conversationType}} {{userList.ticketTaskId}}</p>
                                </div>
                            </div>
                            <div class="single-user" *ngIf="userList.conversationType == 'TASK'" (click)="getSingleConversation(userList.id,userList.userIdNameList[0].userName,'TASK')">
                                <img src="assets/img/dummy-image.jpeg" class="img-avater" alt="" />
                                <div>
                                    <p>{{userList.conversationType}} {{userList.ticketTaskId}}</p>
                                    <p>{{userList.conversationType}} {{userList.ticketTaskId}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-9 col-md-9">
                    <div class="user-chart" *ngIf="userIdNameList.length != 0">
                        <div class="user-chart-header" *ngFor="let user of singleUserChart;let i = index">
                            <div *ngIf="user.conversationType == 'ONE_TO_ONE'">
                                <h3 class="user-chart-header-title">{{user.userIdNameList[1].userName}}</h3>
                                <!-- <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi bi-info-circle" viewBox="0 0 16 16">
                                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                    <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>
                                </svg> -->
                            </div>
                            <div *ngIf="user.conversationType == 'TICKET'">
                                <h3 class="user-chart-header-title">TICKET #{{user.ticketTaskId}}</h3>
                                <svg xmlns="http://www.w3.org/2000/svg" (click)="getTicketTaskByID(user.ticketTaskId)" data-toggle="modal" data-target="#ticketview" fill="currentColor" class="bi bi-info-circle" viewBox="0 0 16 16">
                                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                    <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>
                                </svg>
                            </div>
                            <div *ngIf="user.conversationType == 'TASK'">
                                <h3 class="user-chart-header-title">TASK #{{user.ticketTaskId}}</h3>
                                <svg xmlns="http://www.w3.org/2000/svg" (click)="getSingleTask(user.ticketTaskId)" data-toggle="modal" data-target="#exampleModalCenter" fill="currentColor" class="bi bi-info-circle" viewBox="0 0 16 16">
                                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                    <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>
                                </svg>
                            </div>
                        </div>
                        <div class="user-chart-content">
                            <div #scrollMe class="user-chart-data">
                                <div *ngFor="let conversation of conversationObj;let i = index;let last = last" >

                                    <div class="conversation-r" *ngIf="conversation.userId == userId">
                                        <div class="text-r">
                                            <p>{{conversation.conversation}}</p>
                                            <span>{{conversation.conversationDate | date}}</span>
                                        </div>
                                    </div>
                                    <div class="conversation-l" *ngIf="conversation.userId != userId">
                                        <div class="text-l">
                                            <p>{{conversation.conversation}}</p>
                                            <span>{{conversation.conversationDate | date}}</span>
                                        </div>
                                    </div>
                                    <!-- <p *ngIf="conversation.userId != userId" style="text-align: start">{{conversation.conversation}}</p>
                                    <p *ngIf="conversation.userId == userId" style="text-align: end">{{conversation.conversation}}</p> -->
                                </div>

                            </div>
                            <div class="user-chart-input">
                                <textarea name="" id="" [(ngModel)]="conversation" rows="3"></textarea>
                                <button (keyup.enter)="chartSubmit()" (click)="chartSubmit()">send</button>
                            </div>
                        </div>
                    </div>
                </div>
              </div>

            </div>
  
        </div>
    </div>
</div>



<div class="modal fade" id="ticketview" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="task-content">
          <div class="c-button">
            <div class="c-right" *ngFor="let ticket of TicketData;">
              <h4>Ticket Id: #{{ticket.id}}</h4>
              <!-- <div class="task-status-bar">
                <ul>
                  <li class="activeStatus" (click)="activeStatus('All')" id="All">All</li>
                  <li id="New">New</li>
                  <li id="Completed">Completed</li>
                  <li id="Pending">Pending</li>
                  <li id="Canceled">Canceled</li>
                </ul>
              </div> -->
            </div>
            <div style="align-items: center;">
              <!-- <input type="text" name="" id=""> -->
              <!-- <svg (click)="insertConversation()" xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" class="bi bi-chat-left-dots" viewBox="0 0 16 16">
                <path d="M14 1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H4.414A2 2 0 0 0 3 11.586l-2 2V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12.793a.5.5 0 0 0 .854.353l2.853-2.853A1 1 0 0 1 4.414 12H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/>
                <path d="M5 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>
              </svg> -->
              <svg xmlns="http://www.w3.org/2000/svg" style="margin-left: 10px" data-dismiss="modal" width="26" height="26" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
              </svg>
            </div>
          </div>
         <div class="task-data">
          <ul class="task-header1">
            <li style="width: 20%;">Heading</li>
            <li style="width: 25%;">Details	</li>
            <li style="width: 20%;">Customer ID	</li>
            <li style="width: 20%;">Customer Type	</li>
            <li style="width: 15%;">Status</li>
          </ul>
          <div class="task-table" style="margin-bottom: 10px;" *ngFor="let ticket of TicketData;">
            <ul>
              <li style="width: 20%;">{{ticket.heading}}</li>
              <li style="width: 25%;">{{ticket.details}}</li>
              <li style="width: 20%;">{{ticket.customerID}}</li>
              <li style="width: 20%;">{{ticket.customerName}}</li>
              <li style="width: 15%;">{{ticket.ticketStatus}}</li>
            </ul>
          </div>  
    
    
          <ul class="task-header">
            <li style="width: 9%;">Task-Id</li>
            <li>Name</li>
            <li>Completed %</li>
            <li>Create on</li>
            <li style="width: 12%;text-align: center;">Status</li>
            <li></li>
          </ul>
          <div class="task-table" *ngFor="let task of TicketTaskdata;let i = index">
            <ul>
              <li style="width: 9%;">#{{task.id}}</li>
              <li>{{task.name}}</li>
              <li style="padding-left: 20px">{{task.completedPercentage}} %</li>
              <li>{{task.createdDate | date}}</li>
              <li style="width: 12%;text-align: center;" class="{{task.status[0].taskStatus}}">{{task.status[0].taskStatus | titlecase}}</li>
              <li><a (click)="addc(i)"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-down" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
              </svg></a></li>
            </ul>
            <div class="dropdown-data" id="{{i}}">
              <div class="assignedToAndTags">
    
                <div class="assignedTo">
                  <p> <span>Assign to</span> <span>: &nbsp; {{task.assignedToUserName}}</span></p>
                </div>
                <div class="usersTaged">
                  <p> <span>Users taged</span> <span *ngFor="let user of task.tagUsers;let u = index"> <span *ngIf="u == 0">: &nbsp;</span>  {{user.userName}},</span></p>
                </div>
              </div>
    
              <!-- <div class="dataTablesContent">
                <div class="left">
                  <p><span>Listing number</span> <span>: &nbsp; {{task.taskListingNumber}}</span></p>
                  <p><span>SI number</span> <span>: &nbsp; {{task.taskSINumber}}</span></p>
                  <p><span>SL number</span> <span>: &nbsp; {{task.taskSlNo}}</span></p>
                </div>
                <div class="right">
                  <p> <span>Reg id</span> <span>: &nbsp; {{task.taskRegId}}</span></p>
                  <p> <span>Reg type</span> <span>: &nbsp; {{task.taskRegType}}</span></p>
                </div>
              </div> -->
              <p class="task-description"><span>Description :</span> {{task.description}}</p>
              <!-- <p class="task-description"><span>Note :</span> The lorem generator is nice but it’s code completing functionality makes it indispensable. Once you learn the syntax you can code a whole wireframe with just a few keystrokes.</p> -->
    
              <!-- <div class="taskTable">
                <div>
                  <table class="table">
                    <thead>
                      <tr>
                        <th scope="col">Act duration</th>
                        <th scope="col">Act end date</th>
                        <th scope="col">Act start date</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{{task.taskActDuration | date}}</td>
                        <td>{{task.taskActEndDate | date}}</td>
                        <td>{{task.taskActStartDate | date}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
    
                <div>
                  <table class="table">
                    <thead>
                      <tr>
                        <th scope="col">Exp duration</th>
                        <th scope="col">Exp end date</th>
                        <th scope="col">Exp start date</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{{task.taskExpDuration | date}}</td>
                        <td>{{task.taskExpEndDate | date}}</td>
                        <td>{{task.taskExpStartDate | date}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div> -->
    
    
            </div>
          </div>
         </div>
        </div>
        <!-- <div class="modal-footer">
          <button type="button" id="closeModalButton"   class="btn btn-secondary" data-dismiss="modal" class="btn btn-secondary">Cancel</button>
        </div> -->
      </div>
    </div>
    </div>



    <div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
          <div class="modal-content">
            <div class="task-content">
              <div class="c-button">
                <div class="c-right">
                  <h4>Tasks:</h4>
                  <!-- <div class="task-status-bar">
                    <ul>
                      <li class="activeStatus" (click)="activeStatus('All')" id="All">All</li>
                      <li id="New">New</li>
                      <li id="Completed">Completed</li>
                      <li id="Pending">Pending</li>
                      <li id="Canceled">Canceled</li>
                    </ul>
                  </div> -->
                </div>
                <div style="align-items: center;">
                  <!-- <input type="text" name="" id=""> -->
                  <!-- <svg (click)="insertConversation()" xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" class="bi bi-chat-left-dots" viewBox="0 0 16 16">
                    <path d="M14 1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H4.414A2 2 0 0 0 3 11.586l-2 2V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12.793a.5.5 0 0 0 .854.353l2.853-2.853A1 1 0 0 1 4.414 12H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/>
                    <path d="M5 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>
                  </svg> -->
                  <svg xmlns="http://www.w3.org/2000/svg" style="margin-left: 10px" data-dismiss="modal" width="26" height="26" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                    <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
                  </svg>
                </div>
              </div>
             <div class="task-data">
        
              <ul class="task-header">
                <li style="width: 9%;">Task-Id</li>
                <li>Name</li>
                <li>Completed %</li>
                <li>Create on</li>
                <li style="width: 25%;text-align: center;">Status</li>
              </ul>
              <div class="task-table" *ngFor="let task of task;let i = index">
                <ul>
                  <li style="width: 9%;">#{{task.id}}</li>
                  <li>{{task.name}}</li>
                  <li style="padding-left: 20px">{{task.completedPercentage}} %</li>
                  <li>{{task.createdDate | date}}</li>
                  <li style="width: 25%;text-align: center;position: relative;background-color: white;">
                    <span class="NEW">{{task.latestStatus}}
                      <!-- <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi bi-chevron-down" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
                      </svg> -->
                    </span>
                  </li>
                </ul>
                <div class="dropdown-data dropdown-data-show" id="{{i}}">
            
                  <div class="assignedToAndTags">
                    <div class="assignedTo">
                      <p> <span>Assign to</span><span>: &nbsp; {{task.assignedToUserName}}</span> 
                      </p>
                    </div>
                    <div class="usersTaged">
                      <p> <span>Users taged</span> <span *ngFor="let user of task.tagUsers;let u = index"> <span *ngIf="u == 0">: &nbsp;</span>  {{user.userName}},</span></p>
    
                    </div>
                  </div>
                  <p class="task-description"><span>Description :</span> {{task.description}}</p>
    

        
                  <div class="status-table">
                    <table class="table">
                      <thead>
                        <tr>
                          <th style="width: 50%;">Note</th>
                          <th style="width: 20%;text-align: center;">Status</th>
                          <th style="width: 30%;text-align: center;">Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let status of task.status">
                          <td style="width: 50%;">{{status.note}}</td>
                          <td style="width: 20%;text-align: center;">{{status.taskStatus}}</td>
                          <!-- <td style="width: 15%;">{{status.updatedDate | date}}</td> -->
                          <td style="width: 30%;text-align: center;">{{status.updatedDate | date:'medium'}}</td>
    
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <!-- <div class="dataTablesContent">
                    <div class="left">
                      <p><span>Listing number</span> <span>: &nbsp; {{task.taskListingNumber}}</span></p>
                      <p><span>SI number</span> <span>: &nbsp; {{task.taskSINumber}}</span></p>
                      <p><span>SL number</span> <span>: &nbsp; {{task.taskSlNo}}</span></p>
                    </div>
                    <div class="right">
                      <p> <span>Reg id</span> <span>: &nbsp; {{task.taskRegId}}</span></p>
                      <p> <span>Reg type</span> <span>: &nbsp; {{task.taskRegType}}</span></p>
                    </div>
                  </div> -->
                  <!-- <p class="task-description"><span>Note :</span> The lorem generator is nice but it’s code completing functionality makes it indispensable. Once you learn the syntax you can code a whole wireframe with just a few keystrokes.</p> -->
        
                  <!-- <div class="taskTable">
                    <div>
                      <table class="table">
                        <thead>
                          <tr>
                            <th scope="col">Act duration</th>
                            <th scope="col">Act end date</th>
                            <th scope="col">Act start date</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>{{task.taskActDuration | date}}</td>
                            <td>{{task.taskActEndDate | date}}</td>
                            <td>{{task.taskActStartDate | date}}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
        
                    <div>
                      <table class="table">
                        <thead>
                          <tr>
                            <th scope="col">Exp duration</th>
                            <th scope="col">Exp end date</th>
                            <th scope="col">Exp start date</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>{{task.taskExpDuration | date}}</td>
                            <td>{{task.taskExpEndDate | date}}</td>
                            <td>{{task.taskExpStartDate | date}}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div> -->
    
                </div>
              </div>
             </div>
            </div>
            <!-- <div class="modal-footer">
              <button type="button" id="closeModalButton"   class="btn btn-secondary" data-dismiss="modal" class="btn btn-secondary">Cancel</button>
            </div> -->
          </div>
        </div>
        </div>